import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';

import { chatRoutePercentage } from 'globals/styles';

import { getChatForm } from '../../app/ChatApp/selectors';
import { submitForm, chatFormInProgress } from '../../app/ChatApp/actions';
import ChatConversationHeader from '../../conversation/ChatConversationHeader';
import ChatFormThread from '../ChatFormThread';
import { handleCloseApp } from '../../../app/App/actions';

export class ChatForm extends PureComponent {
  state = {
    initiated: false,
  };

  onStart = () => {
    this.setState({ initiated: true });
    this.props.formIsInProgress(true);
  };

  handleSubmit = (messages, responses) => {
    const data = messages.reduce((acc, currMsg, i) => {
      // By design the first question is always the user's
      if (i === 0) {
        acc.push({ input: currMsg.body, inputAt: currMsg.inputAt });
        return acc;
      }

      if (get(currMsg, 'prompt')) {
        const userResponse = responses.find(resp => resp.id === currMsg.id);
        if (userResponse) {
          if (get(currMsg, 'values') || get(currMsg, 'property', '').includes('Tree')) {
            acc.push({
              prompt: currMsg.body,
              promptAt: currMsg.promptAt,
              id: currMsg.id,
              value: userResponse.value,
              input: userResponse.input,
              inputAt: userResponse.inputAt,
            });
          } else {
            acc.push({
              prompt: currMsg.body,
              promptAt: currMsg.promptAt,
              id: currMsg.id,
              input: userResponse.input,
              inputAt: userResponse.inputAt,
            });
          }
        } else {
          acc.push({
            prompt: currMsg.body,
            promptAt: currMsg.promptAt,
            id: currMsg.id,
          });
        }
        return acc;
      }

      return acc;
    }, []);
    return this.props.submit(data);
  };

  render() {
    const { handleClose, questions, formPrefill } = this.props;
    const { initiated } = this.state;
    if (!questions.length) return null;
    return (
      <div style={{ height: `${chatRoutePercentage}%`, display: 'flex', flexDirection: 'column' }}>
        <ChatConversationHeader onCloseClick={handleClose} expanded={!initiated} hasAgent={false} showOrgAvatar />
        <ChatFormThread
          onSubmit={this.handleSubmit}
          formPrefill={formPrefill}
          questions={questions}
          handleOnStart={this.onStart}
        />
      </div>
    );
  }
}

export const mapStateToProps = state => {
  const form = getChatForm(state);
  return {
    questions: form.questions,
    formPrefill: form.formPrefill,
  };
};

export const mapDispatchToProps = dispatch => {
  return {
    handleClose() {
      dispatch(handleCloseApp());
    },
    formIsInProgress() {
      dispatch(chatFormInProgress(true));
    },
    submit(data) {
      dispatch(chatFormInProgress(false));
      return dispatch(submitForm({ messages: data }));
    },
  };
};

ChatForm.propTypes = {
  questions: React.PropTypes.arrayOf(React.PropTypes.object),
  formPrefill: React.PropTypes.string,
  handleClose: React.PropTypes.func,
  formIsInProgress: React.PropTypes.func,
  submit: React.PropTypes.func,
};

ChatForm.defaultProps = {
  questions: [],
  formPrefill: null,
  handleClose: () => {},
  formIsInProgress: () => {},
};

export default connect(mapStateToProps, mapDispatchToProps)(ChatForm);
